"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brand400 = exports.brand550 = exports.brand500 = exports.brand600 = void 0;
exports.brand600 = '#343D48'; // Charcoal
exports.brand500 = '#06AC47'; // Green
exports.brand550 = '#018436'; // Forest
exports.brand400 = '#D6DCDC'; // Silver
//# sourceMappingURL=legacy.js.map